import { render, staticRenderFns } from "./LocationSet.vue?vue&type=template&id=5b4f1060"
import script from "./LocationSet.vue?vue&type=script&lang=js"
export * from "./LocationSet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports